import service from "@/store/services/agencias-service";

const state = {
  list: {},
  agencia: {},
  listActive: {},
  listUser: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, agencia) => {
    state.agencia = agencia;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_LIST_USER: (state, listUser) => {
    state.listUser = listUser;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  listUser({ commit, dispatch }, params) {
    return service.listUser(params).then(({ listUser }) => {
      commit("SET_LIST_USER", listUser);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then(role => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(agencia => {
      commit("SET_RESOURCE", agencia);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then(agencia => {
      commit("SET_RESOURCE", agencia);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total,
  listActive: state => state.listActive,
  listUser: state => state.listUser,
  agencia: state => state.agencia,
  dropdown: state => {
    return state.list.map(agencia => ({
      id: agencia.id,
      nombre: agencia.nombre,
    }));
  }
};

const agencias = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default agencias;
